import React, { useContext } from 'react';
import c from 'classnames';
import { useSelector } from 'react-redux';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getIsNegativePromptInputVisible, getVariationTarget } from '../../../redux/form/selectors';
import ImageSimilaritySliderField from './ImageSimilaritySliderField';
import ImageSimilaritySelectField from './ImageSimilaritySelectField';
import AspectRatioRadioField from './AspectRatioRadioField';
import AspectRatioSelectField from './AspectRatioSelectField';
import PromptStrengthSliderField from './PromptStrengthSliderField';
import PromptStrengthSelectField from './PromptStrengthSelectField';
import ArtStyleField from './ArtStyleField';
import NegativePromptToggle from './NegativePromptToggle';
import NegativePromptTextArea from './NegativePromptTextArea';
import s from './SettingsPanel.scss';
const SettingsPanel = ({ className })=>{
    const isMobile = useContext(MobileContext);
    const variationTarget = useSelector(getVariationTarget);
    const isNegativePromptInputVisible = useSelector(getIsNegativePromptInputVisible);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(ArtStyleField, null), isMobile ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['mobile-aspect-ratio-and-prompt-strength-row']
    }, !variationTarget && /*#__PURE__*/ React.createElement(AspectRatioSelectField, null), variationTarget && /*#__PURE__*/ React.createElement(ImageSimilaritySelectField, null), /*#__PURE__*/ React.createElement(PromptStrengthSelectField, null)), /*#__PURE__*/ React.createElement("div", {
        className: s['mobile-negative-prompt-toggle-and-text-area']
    }, /*#__PURE__*/ React.createElement(NegativePromptToggle, {
        size: "large"
    }), isNegativePromptInputVisible && /*#__PURE__*/ React.createElement(NegativePromptTextArea, {
        minRows: 2,
        maxRows: 7
    }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !variationTarget && /*#__PURE__*/ React.createElement(AspectRatioRadioField, null), variationTarget && /*#__PURE__*/ React.createElement(ImageSimilaritySliderField, null), /*#__PURE__*/ React.createElement("div", {
        className: s['slider-and-negative-prompt-toggle-row']
    }, /*#__PURE__*/ React.createElement(PromptStrengthSliderField, null), /*#__PURE__*/ React.createElement(NegativePromptToggle, {
        size: "small"
    })), isNegativePromptInputVisible && /*#__PURE__*/ React.createElement(NegativePromptTextArea, {
        minRows: 3,
        maxRows: 5
    })));
};
SettingsPanel.displayName = 'SettingsPanel';
export default SettingsPanel;

//# sourceMappingURL=SettingsPanel.js.map